import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateContactRequest, UpdateContactRequest, GetContactsParams } from '@/types/contact';
import { contactService } from '../../services/contact.service';

export const contact = {
  getContacts: createAsyncThunk(
    'contact/getContacts',
    async (params: GetContactsParams | undefined, { rejectWithValue }) => {
      try {
        const response = await contactService.getContacts(params);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch contacts');
      }
    }
  ),

  createContact: createAsyncThunk(
    'contact/createContact',
    async (contactData: CreateContactRequest, { rejectWithValue }) => {
      try {
        const response = await contactService.createContact(contactData);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to create contact');
      }
    }
  ),

  getContact: createAsyncThunk(
    'contact/getContact',
    async (contactId: string, { rejectWithValue }) => {
      try {
        const response = await contactService.getContact(contactId);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch contact');
      }
    }
  ),

  updateContact: createAsyncThunk(
    'contact/updateContact',
    async (
      { contactId, contactData }: { contactId: string; contactData: UpdateContactRequest },
      { rejectWithValue }
    ) => {
      try {
        const response = await contactService.updateContact(contactId, contactData);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to update contact');
      }
    }
  ),

  deleteContact: createAsyncThunk(
    'contact/deleteContact',
    async (contactId: string, { rejectWithValue }) => {
      try {
        await contactService.deleteContact(contactId);
        return contactId;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to delete contact');
      }
    }
  ),
};
